import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './stores'
import vuetify from '@/plugins/vuetify'
import ApiService from '@/services/api.service'
// import Axios from 'axios'
import VueGtag from 'vue-gtag-next'
import vueCountryRegionSelect from 'vue3-country-region-select'
import { VueCountryCode } from 'vue3-country-select'
import 'vue3-country-select/style.css'
import PrimeVue from 'primevue/config'
import InputText from 'primevue/inputtext'
import Password from 'primevue/password'
import Button from 'primevue/button'
import 'primevue/resources/themes/saga-blue/theme.css'
import 'primeicons/primeicons.css'

ApiService.init(process.env.VUE_APP_BACKEND_API_PROXY_URL)

// Vue.prototype.$http = Axios
// Vue.config.devtools = true

const app = createApp(App)

app.use(vueCountryRegionSelect)
app.component('VueCountryCode', VueCountryCode)
app.component('InputText', InputText)
app.component('AppPassword', Password)
app.component('AppButton', Button)
app.use(PrimeVue)

app.use(VueGtag, {
  property: {
    id: process.env.VUE_APP_GOOGLE_ANALYTICS_TRACKING_CODE
  }
}, router)

app.use(router)
app.use(store)
app.use(vuetify)
app.mount('#app')